import type { StrapiBlogCategory } from '@/types/blog';

export type BlogUrlOptions = {
  pagination?: {
    pageNumber?: number;
    pageSize?: number;
  };
  isFeatured?: boolean;
  category?: StrapiBlogCategory;
  slug?: string;
};

export const DEFAULT_BLOGS_PER_PAGE = 10;

export function getBlogPath(options: BlogUrlOptions): string {
  const { pagination = {}, isFeatured, category, slug } = options;
  const { pageNumber, pageSize = DEFAULT_BLOGS_PER_PAGE } = pagination;

  const queryParams = new URLSearchParams();
  queryParams.set('sort', 'CreatedOn:DESC');
  queryParams.set('populate', '*');

  if (pageNumber !== undefined) {
    queryParams.set('pagination[page]', pageNumber.toString());
    queryParams.set('pagination[pageSize]', pageSize.toString());
  }
  if (isFeatured !== undefined) {
    queryParams.set('filters[IsFeatured][$eq]', isFeatured.toString());
  }
  if (category !== undefined) {
    queryParams.set('filters[Category][$eq]', category);
  }
  if (slug !== undefined) {
    queryParams.set('filters[Slug][$eq]', slug);
  }

  return `/blogs?${queryParams.toString()}`;
}
